import { render, staticRenderFns } from "./TeachingAdminNewDialog.vue?vue&type=template&id=5ec04d84"
import script from "./TeachingAdminNewDialog.vue?vue&type=script&lang=js"
export * from "./TeachingAdminNewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports